import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import Translate from "../../utils/Translate";
import StUnitListItem from "../pick/StUnitListItem";
import { useRef, useState } from "react";
import { partType } from "../../utils/part";
import ButtonWithSpinner from "../ButtonWithSpinner";
import YesOrNoDialog from "../YesOrNoDialog";

function disableStUnit({ bestBeforeDate }) {
  return bestBeforeDate ? new Date(bestBeforeDate) < new Date() : false;
}

function getStUnitSelectedByDefault(stUnits) {
  return stUnits && stUnits.filter((s) => !disableStUnit(s)).length > 0
    ? stUnits.filter((s) => !disableStUnit(s))[0].stUnitId
    : null;
}

function computeAvailableQty(stUnit, alreadySelectedStUnitPicks) {
  const originalQty = stUnit.qty;
  const reservedQty = alreadySelectedStUnitPicks
    .filter((st) => st.stUnitId === stUnit.stUnitId)
    .map((st) => st.qtyToPick)
    .reduce((acc, qty) => acc + qty, 0);
  return originalQty - reservedQty;
}

export default function SelectMultiPartChildStUnitDialog({
  childPart,
  stUnits,
  maxQtyToPick,
  alreadySelectedStUnitPicks,
  onClose,
  onPickStUnit,
}) {
  const [pickQty, setPickQty] = useState(null);
  const [selectedStUnitId, setSelectedStUnitId] = useState(getStUnitSelectedByDefault(stUnits));

  return (
    <Dialog open onClose={onClose} maxWidth={false} className="mediumCourseDialog" scroll="paper">
      <DialogTitle>{`${Translate.get("SelectSpecificPickArea")}: ${childPart.description}`}</DialogTitle>
      <DialogContent>
        {stUnits && stUnits.length > 0 ? (
          <List>
            {stUnits.map((st) => (
              <StUnitListItem
                key={st.stUnitId}
                {...st}
                qty={computeAvailableQty(st, alreadySelectedStUnitPicks)}
                selected={st.stUnitId === selectedStUnitId}
                onSelect={() => setSelectedStUnitId(st.stUnitId)}
                disabled={disableStUnit(st)}
              />
            ))}
          </List>
        ) : (
          <Stack width="100%" justifyContent="center" alignItems="center" marginTop="20px">
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
              }}
            >
              {Translate.get("NoStUnitAvailable")}
            </Typography>
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Grid
 container
 justifyContent="flex-end"
 alignItems="flex-end"
 direction="column"
 spacing={1}
 marginTop="10px"
 marginLeft="0px"
 marginRight="16px"
 marginBottom="8px"
 >
          <Grid container justifyContent="flex-end" alignItems="stretch" direction="row" spacing={1}>
            <Grid size={3}>
              <ButtonWithSpinner
                sx={{ height: "40px" }}
                variant="outlined"
                fullWidth
                disabled={pickQty > maxQtyToPick || !selectedStUnitId}
                onClick={() => (pickQty > 0 ? onPickStUnit(selectedStUnitId, pickQty) : null)}
              >
                {Translate.get("Pick")}:{" "}
              </ButtonWithSpinner>
            </Grid>
            <Grid size={3}>
              <TextField
                value={pickQty ?? ""}
                disabled={!stUnits || stUnits.length === 0}
                onChange={(ev) => setPickQty(ev.target.value ? Number(ev.target.value) : 0)}
                placeholder={Translate.get("Quantity")}
                fullWidth
                size="small"
                inputProps={{
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                  type: "number",
                  min: 1,
                  max: maxQtyToPick,
                }}
                error={
                  pickQty > maxQtyToPick ||
                  (selectedStUnitId && stUnits.find((st) => st.stUnitId === selectedStUnitId).qty < pickQty)
                }
                helperText={
                  pickQty > maxQtyToPick
                    ? `${Translate.get("Max")} ${maxQtyToPick}`
                    : selectedStUnitId && stUnits.find((st) => st.stUnitId === selectedStUnitId).qty < pickQty
                      ? Translate.get("StUnitQtyNotEnough")
                      : ""
                }
              />
            </Grid>
          </Grid>
          <Grid container justifyContent="space-between" alignItems="flex-end" direction="row">
            <Grid >{/* Empty on purpose */}</Grid>
            <Grid container justifyContent="center" size={6}>
              <Grid >{Translate.get("Or").toLowerCase()}</Grid>
            </Grid>
          </Grid>

          <Grid container justifyContent="space-between" alignItems="flex-end" direction="row">
            <Grid >
              <Button onClick={onClose}>{Translate.get("Cancel")}</Button>
            </Grid>
            <Grid size={6}>
              <ButtonWithSpinner
                fullWidth
                disabled={!selectedStUnitId || stUnits.find((st) => st.stUnitId === selectedStUnitId).qty < pickQty}
                variant="contained"
                onClick={() => onPickStUnit(selectedStUnitId, maxQtyToPick)}
              >{`${Translate.get("Pick")} ${Translate.get("All")} (${maxQtyToPick})`}</ButtonWithSpinner>
            </Grid>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
